module.exports = __webpack_public_path__ + "8967be3b8dcaf87d2cac4e01d877b688.pdf";